import { get, post, postPublicChatBot } from '../service';

export const getAllChatBots = async () => {
  const response = await get('/chatbot/get-all-chatbots');

  if (response.status === 200) {
    const responseData = response.data;
    return responseData;
  }
  throw new Error('Failed to fetch chatbots');
};

export const getInvoiceList = async (payload) => {
  const response = await postPublicChatBot('/invoice/list', payload);

  if (response.status === 200) {
    const responseData = response.data;
    return responseData;
  }
  throw new Error('Failed to fetch invoice list');
};

export const getInvoice = async (payload) => {
  const response = await postPublicChatBot('/invoice/get', payload);

  if (response.status === 200) {
    const responseData = response.data;
    return responseData;
  }
  throw new Error('Failed to fetch invoice');
};

export const createCouncilAgent = async (payload) => {
  try {
    const response = await post('/admin/chatbots/create', payload);

    if (response.status === 200) {
      const responseData = response.data;
      return responseData;
    }
    throw new Error('Failed to create chatbot');
  } catch (error) {
    throw new Error(error?.response?.data?.message || error?.message || 'Failed to create chatbot');
  }
};

export const updateCouncilAgent = async (payload) => {
  try {
    const response = await post('/admin/chatbots/update', payload);

    if (response.status === 200) {
      const responseData = response.data;
      return responseData;
    }
    throw new Error('Failed to update chatbot');
  } catch (error) {
    throw new Error(error?.response?.data?.message || error?.message || 'Failed to update chatbot');
  }
};

export const replaceCouncilLogo = async (payload) => {
  try {
    const response = await post('/admin/chatbots/replace-logo', payload);

    if (response.status === 200) {
      const responseData = response.data;
      return responseData;
    }
    throw new Error('Failed to update chatbot');
  } catch (error) {
    throw new Error(error?.response?.data?.message || error?.message || 'Failed to update chatbot');
  }
};
